"use client";

import { useTranslations } from "next-intl";
import type { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { CaloriesCalculatorFormType } from "../schemas/calories-calculator-schema";

const genders = ["female", "male"] as const;

export const CaloriesCalculatorGenderField = ({
  form,
}: {
  form: UseFormReturn<CaloriesCalculatorFormType>;
}) => {
  const t = useTranslations("calories-calculator");

  return (
    <FormField
      control={form.control}
      name="gender"
      render={({ field }) => (
        <FormItem className="space-y-0">
          <FormControl>
            <RadioGroup
              className="flex min-h-11 flex-row items-center gap-12 md:gap-14"
              onValueChange={field.onChange}
              value={field.value}
            >
              {genders.map((gender) => (
                <FormItem
                  className="flex items-center space-x-2 space-y-0"
                  key={gender}
                >
                  <FormControl>
                    <RadioGroupItem
                      className="size-5 border-border text-white data-[state=checked]:border-brand-green2-300 data-[state=checked]:bg-brand-green2-300 [&_svg]:size-2"
                      value={gender}
                    />
                  </FormControl>
                  <FormLabel className="cursor-pointer font-normal text-base text-text">
                    {t(`gender.${gender}`)}
                  </FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
